import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import chairTaiChiFImg from '@/assets/landing/chair-tai-chi-f.webp'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('activity-male-chair-tai-chi.landing.loader.title'),
			size: 'small',
			customStyles: {
				marginLeft: '2rem',
				marginRight: '2rem',
			},
		}),

		LandingImage: (): LandingComponentsConfig['LandingImage'] => {
			return {
				img: chairTaiChiFImg,
				customStyles: {
					width: 'calc(100% + 40px)',
					maxWidth: 'none',
					marginLeft: '-20px',
					marginRight: '-20px',
					marginTop: 'var(--size-64)',
					marginBottom: 'var(--size-64)',
				},
			}
		},

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
